import { useCallback, useRef } from 'react';

export function useDebouncedCallback<Fn extends (...args: any[]) => void>(func: Fn, wait: number) {
  const timeout = useRef<NodeJS.Timeout>();

  return useCallback(
    (...args: Parameters<Fn>) => {
      const later = () => {
        clearTimeout(timeout.current);
        func(...args);
      };

      clearTimeout(timeout.current);
      timeout.current = setTimeout(later, wait);
    },
    [func, wait]
  );
}
